<template>
    <div class="py-2 flex justify-between items-center">
        <div class="flex items-center">
            <IconColorPicker
                class="w-5 h-5 icon-color-picker"
                :style="color"
            />
            <div class="flex items-center mx-2 text-main-sm whitespace-nowrap main-text-color">
                {{ makePrefixForTranslation(LayoutParameterName) }}:
            </div>
        </div>
        <SoundSelect
            v-model="sound"
            :placeholder="$t('general.sound')"
            :options="sounds"
        />
    </div>
</template>
<script>
    import { Option, Select} from 'element-ui'
    import SoundSelector from './SoundSelector.vue'
    import SoundSelect from "@/components/Common/SoundSelect.vue";

    export default {
        name: 'SingleSoundSelector',
        props: {
            value: {
                required: true
            },
            LayoutParameterName: {
                type: String,
                default: '',
            },
        },
        components: {
            SoundSelect,
            [Select.name]: Select,
            [Option.name]: Option,
            SoundSelector
        },
        data() {
            return {
                sounds: [],
                sound: 'none',
                color: ''
            }
        },
        computed: {
            warningSounds () {
                return this.$store.getters['entities/getWarningSounds']
            },
            errorSounds () {
                return this.$store.getters['entities/getErrorSounds']
            },
            activeLayout() {
                return this.$store.getters['layout/getActiveLayout']
            }
        },
        async mounted() {
            this.makeSoundList()
            if (this.value) {
                this.sound = this.value
            } else {
                this.sound = 'none'
            }
            const warningCallColors = this.activeLayout.LayoutParametersList.filter((el) => el.LayoutParameterName.includes('WarningColor'))
            const limitTimeColors = this.activeLayout.LayoutParametersList.filter((el) => el.LayoutParameterName.includes('LimitColor'))

            const key = `${this.LayoutParameterName.replace('Sound', '')}Color`
            const allTimerColors = warningCallColors.concat(limitTimeColors)

            this.color = {
                color: allTimerColors.find(el => el.LayoutParameterName === key).Value || 'black'
            }
        },
        methods: {
            makePrefixForTranslation (string) {
                const makeFirstLetterInLowerCase = (string) => string.charAt(0).toLowerCase() + string.slice(1)
                return this.$t(`layout.config.${makeFirstLetterInLowerCase(string)}`)
            },
            makeSoundList () {
                this.sounds = this.LayoutParameterName.toLowerCase().includes('warning') ? this.warningSounds : this.errorSounds
            }
        },
        watch: {
            sound (val) {
                if (val) {
                    this.$emit('update:value', val)
                    this.$emit('input', val)
                }
            }
        }
    }
</script>

<style>
.sound-select {
    width: 180px;
}
</style>
